module.exports = __webpack_public_path__ + "img/1458381230.3dc14645.jpg";